const { getElement } = window.BAO.Utils

const PhotoSwipe = window.PhotoSwipe
const PhotoSwipeLightbox = window.PhotoSwipeLightbox

export class ProductPhotoSwipe extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.link?.exists) return

    this.photoSwipeInstance = new PhotoSwipeLightbox({
      loop: false,
      showAnimationDuration: 500,
      scaleMode: 'zoom',

      initialZoomLevel: 'fit',
      secondaryZoomLevel: 1,
      maxZoomLevel: 1.5,

      gallery: this,
      children: this.els.link.selector,
      bgOpacity: 1,
      arrowPrev: true,
      arrowNext: true,
      zoom: false,
      close: false,
      counter: false,
      preloadFirstSlide: false,
      closeOnVerticalDrag: true,
      tapAction: 'zoom',

      pswpModule: () => {
        return PhotoSwipe
      },
    })

    this.setupPhotoSwipeListeners()
    this.photoSwipeInstance.init()
  }

  setupListeners () {
    super.setupListeners()
  }

  setupPhotoSwipeListeners () {
    this.photoSwipeInstance.on('uiRegister', () => {
      this.addCloseButton()

      this.addPreviousButton()
      this.addNextButton()

      this.addZoomSlider()
    })

    this.photoSwipeInstance.on('change', () => {
      this.handleSlideChange()
    })
  }

  addCloseButton () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-close',
      className: 'pswp-Action_Close',
      ariaLabel: window.theme.strings.photoswipe.close,
      order: 2,
      isButton: true,
      html: this.closeSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.close()
      },
    })
  }

  addPreviousButton () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-prev',
      className: 'pswp-Action_Arrow pswp-Action_Arrow-previous',
      ariaLabel: 'Previous',
      appendTo: 'wrapper',
      order: 1,
      isButton: true,
      html: this.arrowSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.prev()
      },
    })
  }

  addNextButton () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-next',
      className: 'pswp-Action_Arrow pswp-Action_Arrow-next',
      ariaLabel: 'Next',
      appendTo: 'wrapper',
      order: 1,
      isButton: true,
      html: this.arrowSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.next()
      },
    })
  }

  addZoomSlider () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'zoom-slider',
      order: 10,
      isButton: false,
      appendTo: 'root',
      html: `<div class="pswp-ZoomSlider">
                <button class="pswp-ZoomSlider_Control pswp-ZoomSlider_Control-zoomOut" data-pswp-el="zoom-out" title="Zoom Out" type="button">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
                    <path stroke="currentColor" d="M4 8h8"/>
                  </svg>
                </button>

                <input type="range" min="0" max="4" step="0.1" value="1" class="pswp-ZoomSlider_Input">
                
                <button class="pswp-ZoomSlider_Control pswp-ZoomSlider_Control-zoomIn" data-pswp-el="zoom-in" title="Zoom In" type="button">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
                    <path stroke="currentColor" d="M4 8h8M7.995 12.005v-8"/>
                  </svg>
                </button>
              </div>`,

      onInit: (el, pswp) => {
        const slider = el.querySelector('.pswp-ZoomSlider_Input')

        const updateSlider = () => {
          const slide = pswp.currSlide
          const content = slide?.content

          const canZoom =
            slide && typeof slide.isZoomable === 'function'
              ? slide.isZoomable()
              : false

          if (!canZoom) {
            el.style.display = 'none'
            return
          }

          const zoomLevel = pswp.currSlide.currZoomLevel || content?.scale || 1
          const minZoomLevel = slide.zoomLevels.min
          const maxZoomLevel = slide.zoomLevels.max

          el.style.display = 'block'
          slider.min = minZoomLevel
          slider.max = maxZoomLevel
          slider.value = zoomLevel.toFixed(2)
        }

        const updateZoom = () => {
          const zoom = parseFloat(slider.value)
          const slide = pswp.currSlide
          if (slide?.content?.isZoomable) {
            pswp.zoomTo(
              zoom,
              {
                x: pswp.viewportSize.x / 2,
                y: pswp.viewportSize.y / 2,
              },
              0,
            )
          }
        }

        pswp.on('zoomPanUpdate', updateSlider)
        pswp.on('change', updateSlider)
        pswp.on('contentResize', updateSlider)

        slider.addEventListener('input', () => {
          updateZoom()
        })

        el.addEventListener(
          'touchstart',
          (e) => {
            e.stopPropagation()
          },
          { passive: true },
        )

        el.addEventListener(
          'touchmove',
          (e) => {
            e.stopPropagation()
          },
          { passive: true },
        )

        el.addEventListener(
          'click',
          (e) => {
            e.stopPropagation()
          },
          { passive: true },
        )

        const zoomOut = el.querySelector('[data-pswp-el="zoom-out"]')
        zoomOut.addEventListener('click', () => {
          slider.value = slider.value * 1 - 0.5
          updateZoom()
        })

        const zoomIn = el.querySelector('[data-pswp-el="zoom-in"]')
        zoomIn.addEventListener('click', () => {
          slider.value = slider.value * 1 + 0.5
          updateZoom()
        })
      },
    })
  }

  handleSlideChange () {
    const { pswp } = this.photoSwipeInstance
    const previousEl = getElement('.pswp-Action_Arrow-previous')
    const nextEl = getElement('.pswp-Action_Arrow-next')

    if (pswp && previousEl) {
      previousEl.disabled = pswp.currIndex === 0
    }

    if (pswp && nextEl) {
      nextEl.disabled = pswp.currIndex + 1 === pswp.getNumItems()
    }
  }

  get closeSvg () {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <path fill="currentColor" d="m12.795 12 2.602-2.603a.562.562 0 0 0-.795-.795L12 11.205 9.397 8.602a.562.562 0 0 0-.795.795L11.205 12l-2.603 2.602a.563.563 0 0 0 .795.795L12 12.795l2.602 2.602a.563.563 0 1 0 .795-.795z"/>
      </svg>
    `
  }

  get arrowSvg () {
    return `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.80203 15.8052V7.80518L15.182 11.3891C15.479 11.5869 15.479 12.0234 15.182 12.2213L9.80203 15.8052Z" fill="currentColor"/>
      </svg>
    `
  }
}

if (!customElements.get('product-photoswipe')) {
  customElements.define('product-photoswipe', ProductPhotoSwipe)
}
